(function () {
  const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');

  function revealElement(el) {
    el.classList.add('is-revealed');
  }

  function initSectionReveal(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const elements = scope.querySelectorAll('[data-reveal]:not(.is-revealed)');

    if (!elements.length) return;

    if (REDUCED_MOTION.matches) {
      elements.forEach(revealElement);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          revealElement(entry.target);
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.15,
        rootMargin: '0px 0px -10% 0px',
      }
    );

    elements.forEach((el) => observer.observe(el));
  }

  function boot() {
    initSectionReveal(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initSectionReveal(event.target);
  });
})();
